import script from "./appProvider.vue?vue&type=script&setup=true&lang=js"
export * from "./appProvider.vue?vue&type=script&setup=true&lang=js"

import "./appProvider.vue?vue&type=style&index=0&id=25d9d82e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\TECHNOVA_FD01\\Desktop\\Augustine\\Projects\\XP\\payout-fe\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25d9d82e"]])

export default __exports__